export default {
  chats(state) {
    return state.chats
  },
}
